export const steelGrey50 = "#f5f6f7";
export const steelGrey100 = "#ebedf0";
export const steelGrey200 = "#ced4da";
export const steelGrey300 = "#88909f";
export const steelGrey400 = "#7a8394";
export const steelGrey500 = "#6b7588";
export const steelGrey600 = "#5b6578";
export const steelGrey700 = "#4b5568";
export const steelGrey800 = "#3c4558";
export const steelGrey900 = "#2c3548";
export const steelGrey1000 = "#121826";
export const steelGreyA100 = "#c0d2e7";
export const steelGreyA200 = "#a0afc3";
export const steelGreyA400 = "#778fae";
export const steelGreyA500 = "#28334f";
export const steelGreyA1000 = "#10172a";
